import { render, staticRenderFns } from "./EditMultipleColumnsPopup.vue?vue&type=template&id=4b3ee8c1&"
import script from "./EditMultipleColumnsPopup.vue?vue&type=script&lang=js&"
export * from "./EditMultipleColumnsPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports